import { priceForItemOptionModifierPlu } from 'utils/menu/price';
import { mapBackendToFrontend } from 'utils/reorder';
import { routes } from 'utils/routing';

/**
 *
 * Returns a function to reorder a previous order.
 */
export const useHandleReorder = ({
  addToCart,
  navigate,
  posVendor,
  prices,
  pricingFunction,
  setPendingReorder,
  setReordering,
  storeHasSelection,
}) => (order, url) => {
  if (order && storeHasSelection) {
    setReordering(true);
    const { cartEntries } = order.cart;
    const curriedPriceItemOptionModifier = item => modifier =>
      priceForItemOptionModifierPlu({
        item,
        modifier,
        prices,
        posVendor,
      });

    const cartEntriesMappedToFrontend = cartEntries.map(
      mapBackendToFrontend(pricingFunction, curriedPriceItemOptionModifier)
    );

    cartEntriesMappedToFrontend.forEach(entry => addToCart(entry));

    setReordering(false);
    setPendingReorder(null);

    navigate(routes.cart);
  } else {
    // if there's no order or no order or store selection, navigate to where we initially intended
    navigate(url);
  }
};
